import { pipe } from 'fp-ts/function';
import {
  createAuthorizedDeleteRequest,
  createAuthorizedGetRequest,
  createAuthorizedPostRequest,
  createAuthorizedPutRequest,
  decodeVersioned,
  fetchApi,
  setBody,
} from '@/services/api';
import { chain, map } from 'fp-ts/TaskEither';
import { stripeResponseCodec } from '@/services/api/resources/subscription/codec';
import { PlanNickName } from '@/entities/plan/constants';
import { SubscriptionSlugNickName } from '@/entities/subscription/constants';

const baseUrl = '/v2/subscriptions';
const setupIntentBaseUrl = '/v2/setup-intents';
const customerBaseUrl = '/v2/customers';

interface CreateSubscriptionBody {
  slug: SubscriptionSlugNickName;
  interval: PlanNickName;
  quantity: number | string;
}

const freeTrialPayload = { slug: SubscriptionSlugNickName.ProfessionalNew, quantity: 1, interval: PlanNickName.Month };

export const create = (
  // if an empty object is sent a free trial (or free plan) will start for the user
  data: CreateSubscriptionBody | null = freeTrialPayload,
) => pipe(
  baseUrl,
  createAuthorizedPostRequest,
  map(setBody(data)),
  chain(fetchApi),
  chain(decodeVersioned(stripeResponseCodec)),
);

export const deleteInvoice = ({ subscriptionId, invoiceId }: { subscriptionId: string; invoiceId: string }) => pipe(
  `${baseUrl}/${subscriptionId}/invoice/${invoiceId}`,
  createAuthorizedDeleteRequest,
  chain(fetchApi),
);

export const requestSetupIntent = () => pipe(
  setupIntentBaseUrl,
  createAuthorizedGetRequest,
  chain(fetchApi),
);

export const updateCustomer = (
  { name, email, address, city, zip, country, company }: {
    name: string; email: string; address: string; city: string; zip: string; country: string; company: string;
  },
) => pipe(
  customerBaseUrl,
  createAuthorizedPutRequest,
  map(setBody({
    company,
    email,
    name,
    address: {
      address,
      city,
      zip,
      country,
    },
  })),
  chain(fetchApi),
);
